module.exports = __webpack_public_path__ + "img/yl_logo.3cc36892.png";